import { render, staticRenderFns } from "./SstRecords.vue?vue&type=template&id=4492e214&scoped=true&"
import script from "./SstRecords.vue?vue&type=script&lang=js&"
export * from "./SstRecords.vue?vue&type=script&lang=js&"
import style0 from "./SstRecords.vue?vue&type=style&index=0&id=4492e214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4492e214",
  null
  
)

export default component.exports